
export const load = state => state.load;
export const twofa = state => state.twofa;
export const id = state => state.id;
export const client_ref = state => state.client_ref;
export const token = state => state.token;
export const color = state => state.color;
export const logoLink = state => state.logoLink;
export const stylized = state => state.stylized;
export const account_id = state => state.account_id;
export const partner = state => state.partner;
export const email = state => state.email;
export const successStatus = state => state.successStatus;
export const errorStatus = state => state.errorStatus;
export const getCredencialsResponse = state => state.getCredencialsResponse;
export const errorMessage = state => state.errorMessage;
